import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { logPageView } from '../../../models/Analytics';
import { MainContainer } from '../../MainContainer';
import '../styles.less';

interface IProps extends RouteComponentProps<any> {
	className?: string;
}

interface IState {
	showRequestInvitePopup?: boolean;
}

export class HawkSoftPressRelease extends React.Component<IProps, IState> {
	public state: IState = {
		showRequestInvitePopup: false,
	};

	public componentDidMount() {
		window.scrollTo(0, 0);
		document.title = 'Levitate - HawkSoft Launch';
		logPageView('PressRelease:HawkSoft');
	}

	public render() {
		return (
			<MainContainer>
				<div className='terms-outerContainer'>
					<h1>Levitate Partners with HawkSoft Agency Management System to Offer Complete Contact Management and Communication Solution</h1>

					<p>
						<em>Agencies using HawkSoft can now easily and seamlessly integrate with Levitate’s keep-in-touch tools.</em>
					</p>

					<p>
						RALEIGH, NC, April 1, 2020 — Levitate and HawkSoft have partnered to help independent insurance agents focus on what they do best: building relationships.
					</p>

					<p>
						With the launch of their integration, HawkSoft’s customers gain the ability to create intelligent, “keep-in-touch”
						reminders for each of their policyholders and prospects, then send personalized emails at scale.
					</p>

					<p>
						"I'm a big believer in the idea that technology should be used to help build more personal and authentic
						relationships,” says Jesse Lipson, CEO of Levitate. “This partnership between HawkSoft and Levitate will
						help amplify what makes independent insurance agencies so great to begin with: their personal approach.
						We're proud to collaborate with HawkSoft to help independent Insurance agencies succeed."
					</p>

					<p>
						With the integration, Levitate will automatically sync and augment HawkSoft contact profiles with publicly-available
						Facebook and LinkedIn information, then tag them by lines or relationship category.  Users can set up unique reminders
						to reach out, such as on birthdays or renewal dates, and be notified to email contacts they haven’t spoken to in a while.
						Unlike emails sent through mass-blast providers, Levitate emails appear in recipient inboxes as a personal email—creating an authentic,
						1:1 approach to client communication.
					</p>

					<p>
						“Most people can tell when they are a recipient of a mass email because the content is not personalized to them,” says Rushang Shah, VP of Marketing for HawkSoft.
						“Levitate solves this email personalization problem in a unique way by leveraging your existing email service provider to send a personal email to the recipient.
						They use one-to-one interactions over mass email campaigns. HawkSoft is excited to have Levitate as a partner to help our agencies upgrade their keep-in-touch marketing strategies.”
					</p>

					<p>
						All Levitate subscribers also have access to a dedicated Marketing Coach.  In addition to managing a customized “keep-in-touch calendar” for subscribers,
						Levitate coaches write and recommend timely communication in response to current events, such as COVID-19.
					</p>

					<p>
						The HawkSoft and Levitate integration will be available to customers of both services on April 1st.
					</p>

					<h3>Levitate</h3>

					<p>
						Levitate is a software platform designed to help small businesses grow through the lost art of keeping in touch.
						Our solution helps independent insurance agents send personal emails at scale, remember key facts about their contacts,
						customize reminders to reach out, and accomplish account rounding goals with a personalized approach. <a href='https://www.levitate.ai' target='_blank'>www.levitate.ai</a>
					</p>

					<h3>HawkSoft</h3>

					<p>
						Since 1995, HawkSoft is a leader in management systems for agencies that want effective workflows and a delightful experience
						for staff and policyholders. We take pride in being independently owned and answerable to agencies that rely on our system to
						power their insurance business. Created by independent agents, HawkSoft continues to evolve as a cutting-edge system that
						powers thousands of agencies. <a href='https://www.hawksoft.com' target='_blank'>www.hawksoft.com</a>
					</p>

				</div>
			</MainContainer>
		);
	}
}
